/**
 * Компонента-заглушка нужна исключительно для того что бы объявить роут,
 * но без реализации компоненты, которая по этому роуту должна отдаваться
 *
 * @returns {Promise<{readonly default?: {name: string}}>}
 * @constructor
 */
export const Plug = () => import('SharedDir/components/ui/WillBeSoon.vue');

export { requireAnyPermissions, requirePermissions } from 'SharedDir/router/permission-guard';

export interface OnlyAuthorized {
  /**
   * `true` или список идентификаторов ролей пользователей
   * которым доступен данный роут
   */
  authorization?: boolean | Array<number>;
}

/**
 *
 * @param {Array<number> | number} roles
 * @param {T} meta
 * @returns {Record<string, unknown> & {authorization: true | Array<number>}}
 */
export const authorizedOnly = <T extends Record<string, unknown> = {}>(
  roles?: Array<number> | number,
  meta?: T
): T & Required<OnlyAuthorized> => {
  const extraMeta = meta || ({} as T);
  if (!roles) {
    return { ...extraMeta, authorization: true };
  }
  const authorizedRoles = Array.isArray(roles) ? roles : [roles];
  return { ...extraMeta, authorization: authorizedRoles };
};
